import React from 'react';
import styles from './TextGroupSectionG.module.sass';
import Section, { SectionBackgroundStyle } from '../../reusable/section/Section';
import TextContainer from '../../reusable/title_description_group_container/TitleDescriptionGroupContainer';
import { TextGroupStyle } from '../../reusable/title_description_group/TitleDescriptionGroup';
import Arielle from '../../assets/arielle_photo_most.webp';
import MobileSpacer, { SpacerSize } from '../../reusable/mobile_spacer/MobileSpacer';
import Grid from '../../reusable/grid/Grid';
import RevealImage from '../../reusable/reveal/RevealImage';

const title = "Arielle Caplan."
const subtitle = "Occupational Therapist"
const paragraphs = [
  "Arielle is a licensed occupational therapist with a passion for helping children, adolescents, and their families develop the skills they need to thrive in everyday life. She has extensive experience in school-based settings, supporting neurodiverse students in areas such as fine motor development, sensory processing, self-regulation, and activities of daily living. She is particularly passionate about supporting neurodiverse learners in building independence, confidence, and participation in the activities that matter most to them.",
  "Arielle earned her Doctor of Occupational Therapy degree from the Katz School of Science and Health. Her education instilled both a compassionate, family-centered approach to occupational therapy and a deep commitment to scientific, evidence-based practice. Her clinical fieldwork experiences solidified her passion for pediatrics and provided her with practical skills that continue to shape her therapeutic approach. In addition to her doctoral training, Arielle earned an NBCOT Micro-Credential in Autism and has completed specialized training in pediatric sleep and fine motor development.",
  "Arielle brings a strong background in volunteer service, including serving as a counselor at a sleepaway camp for children with special needs and providing respite support to families through home visits. Outside of work, she enjoys spending time with her family, going on walks, and cooking.",
];

export default class TextGroupSectionG extends React.Component {

  render() {
    return (
      <Section style={SectionBackgroundStyle.dark}>
        <RevealImage className={styles.Arielle} src={Arielle} photo />
        <MobileSpacer size={SpacerSize.medium} />
        <Grid>
          <TextContainer
            className={styles.TextContainer}
            dark={false}
            title={title}
            subtitle={subtitle}
            paragraphs={paragraphs} 
            style={TextGroupStyle.small} />
        </Grid>
      </Section>
    )
  }

}